import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("編集")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("停止")

import {
    ref,
    watch,
  } from 'vue'

  interface Row {
    name: string;
    login_id: string;
    manager_flg: boolean;
    role: string;
  }

  interface Props {
    users: Row[];
  }
  interface Emits {
    (e: 'click:edit', value: Row): void,
    (e: 'click:suspend', value: Row): void,
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    users: { type: Array, required: true }
  },
  emits: ["click:edit", "click:suspend"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'click:edit', value: Row): void,
    (e: 'click:suspend', value: Row): void,
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    users: Row[];
  }
  

  

  const handleEdit = (row: Row) => {
    emit('click:edit', row);
  };

  const handleSuspend = (row: Row) => {
    emit('click:suspend', row);
  }

  let manager_count = ref(0);
  watch(() => props.users, (users) => {
    manager_count.value = users.filter((user) => user.manager_flg).length;
  });

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, { data: __props.users }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        prop: "login_id",
        label: "ログインID"
      }),
      _createVNode(_component_el_table_column, {
        prop: "name",
        label: "名前"
      }),
      _createVNode(_component_el_table_column, {
        align: "right",
        label: ""
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_button, {
            class: "row-button",
            onClick: ($event: any) => (handleEdit(scope.row))
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_el_button, {
            disabled: scope.row.manager_flg && _unref(manager_count) <= 1,
            class: "row-button",
            type: "primary",
            onClick: ($event: any) => (handleSuspend(scope.row))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})